// extracted by mini-css-extract-plugin
module.exports = {"postContent":"_39-8-"};